import { render, staticRenderFns } from "./ModalAcademyRequestContents.vue?vue&type=template&id=9950c1fa&scoped=true&lang=pug&"
import script from "./ModalAcademyRequestContents.vue?vue&type=script&lang=ts&"
export * from "./ModalAcademyRequestContents.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAcademyRequestContents.vue?vue&type=style&index=0&id=9950c1fa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9950c1fa",
  null
  
)

export default component.exports